import React from 'react';

import { Icon } from '@flixbus/honeycomb-icons-react';
import { Accordion, Text } from '@flixbus/honeycomb-react';

import styles from './styles.module.css';

/**
 * @typedef {object} BreakdownDetailsRow
 * @property {string} label
 * @property {string} value
 * @property {import('react').ComponentType} [icon]
 */

/**
 * @typedef {object} BreakdownDetailsSection
 * @property {string} id
 * @property {string} title
 * @property {boolean} [defaultOpen]
 * @property {BreakdownDetailsRow[]} rows
 */

const Row = ({ label, value, icon: IconComponent }) => (
	<div className={styles.row}>
		<div className={styles.rowLabel}>
			{IconComponent && <Icon InlineIcon={IconComponent} extraClasses={styles.rowIcon} />}
			<Text extraClasses={styles.rowLabelText}>{label}</Text>
		</div>
		<Text extraClasses={styles.rowValue}>{value}</Text>
	</div>
);

/**
 * Dumb presentational component: renders an accordion per non-empty section.
 * Knows nothing about breakdown-vs-draft — the caller derives `sections` from
 * whichever domain shape it has.
 *
 * @param {{ sections: BreakdownDetailsSection[] }} props
 */
const BreakdownDetails = ({ sections }) => (
	<div className={styles.root}>
		{sections.map((section) => {
			if (!section.rows || section.rows.length === 0) return null;
			return (
				<Accordion
					key={section.id}
					title={section.title}
					open={section.defaultOpen}
					extraClasses={styles.section}
				>
					<div className={styles.rows}>
						{section.rows.map((row) => (
							<Row key={row.label} label={row.label} value={row.value} icon={row.icon} />
						))}
					</div>
				</Accordion>
			);
		})}
	</div>
);

export default BreakdownDetails;
